export default __webpack_public_path__ + "static/media/logo.ba061f1d.png";